<div class="card">
  <slot />
</div>

<style>
  .card {
    position: relative;
    background-color: white;
    color: #333;
    border-radius: 15px;
    padding: 50px;
    margin: 20px 0;
  }
</style>
